import React, { useState, useEffect } from "react";
import GOFloatingbox from "../../common/GOFloatingbox";
import { useTranslation } from "react-i18next";
import GOButton from "../../common/GOButton";
import dayjs from "dayjs";
import * as Styled from "../reservationDeleteStyles";
import {
  NetReservationDeletePlateList,
  NetReservationResCancel,
  NetReservationDeletePlateSchedule
} from "../../../actions";
import ReservationDate from "../ReservationDate";
import {
  UFloatingContainer,
  UFloatingBoxHeader,
  UFloatingBoxFooter,
  UFloatingBoxBody
} from "../../../GlobalUtilityStyles";

interface ReservationAddProps {
  onClickExit?: any;
  update?: any;
  now: any;
}

function Delete(props: ReservationAddProps) {
  const { t } = useTranslation();

  const [data, setData] = useState<any>();
  const [startDate, setStartDate] = useState<any>(null);
  const [startTime, setStartTime] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  const [endTime, setEndTime] = useState<any>(null);
  const [delState, setDelState] = useState<boolean>(false);
  const [searchState, setSearchState] = useState<boolean>(false);
  const [update, isUpdate] = useState<boolean>(false);

  let combineDate = {
    startDay: `${dayjs(startDate).format("YYYY-MM-DD")}T${
      dayjs(startTime).hour() < 10
        ? `0${dayjs(startTime).hour()}`
        : `${dayjs(startTime).hour()}`
    }:${
      dayjs(startTime).minute() < 10
        ? `0${dayjs(startTime).minute()}`
        : `${dayjs(startTime).minute()}`
    }:00`,
    endDay: `${dayjs(endDate).format("YYYY-MM-DD")}T${
      dayjs(endTime).hour() < 10
        ? `0${dayjs(endTime).hour()}`
        : `${dayjs(endTime).hour()}`
    }:${
      dayjs(endTime).minute() < 10
        ? `0${dayjs(endTime).minute()}`
        : `${dayjs(endTime).minute()}`
    }:00`
  };

  const onDeleteUserList = () => {
    if (startDate === null) {
      alert(t("reservation.noStartDate"));
    } else if (startTime === null) {
      alert(t("reservation.noStartTime"));
    } else if (endDate === null) {
      alert(t("reservation.noEndDate"));
    } else if (endTime === null) {
      alert(t("reservation.noEndTime"));
    } else {
      NetReservationDeletePlateList(combineDate.startDay, combineDate.endDay)
        .then((res: any) => {
          setData(res.data.Data.plateReservations);
        })
        .catch((err: any) => console.log(err));
    }
  };

  const onReservationCancel = (id: string) => {
    NetReservationResCancel(id)
      .then((res: any) => isUpdate(!update))
      .catch((err: any) => console.log(err));
  };

  const handleSubmit = () => {
    if (
      startDate === null ||
      startTime === null ||
      endDate === null ||
      endTime === null
    ) {
      alert(t("reservation.checkDate"));
    } else if (data?.length > 0) {
      setDelState(true);
    } else if (searchState) {
      NetReservationDeletePlateSchedule(
        combineDate.startDay,
        combineDate.endDay
      )
        .then((res: any) => {
          alert(t("reservation.deleteComplete"));
          setDelState(false);
          if (props.onClickExit) {
            props.onClickExit();
            props.update();
          }
        })
        .catch((err: any) => console.log(err));
    } else alert(t("reservation.checkReservationBeforeDelete"));
  };

  useEffect(() => {
    if (update) {
      NetReservationDeletePlateList(combineDate.startDay, combineDate.endDay)
        .then((res: any) => {
          setData(res.data.Data.plateReservations);
          isUpdate(false);
        })
        .catch((err: any) => console.log(err));
    }
  }, [update, combineDate.startDay, combineDate.endDay]);

  return (
    <>
      <GOFloatingbox width={520}>
        <UFloatingContainer>
          <UFloatingBoxHeader>
            <h1>{t("reservation.checkReservationBeforeDelete")}</h1>
            <p>{t("reservation.deletePlateSchedule")}</p>
            <Styled.WarningMessage>
              {t("reservation.deletePlateScheduleWarning")}
            </Styled.WarningMessage>
          </UFloatingBoxHeader>
          <UFloatingBoxBody>
            <div className="flex_box">
              <Styled.DateBox>
                <ReservationDate
                  name={t("common.startDay")}
                  dateName="startDate"
                  date={startDate}
                  onChange={(date: any) => {
                    setStartDate(dayjs(date));
                  }}
                />
                <ReservationDate
                  name={t("common.time")}
                  dateName="startTime"
                  date={startTime}
                  onChange={(date: any) => {
                    setStartTime(dayjs(date));
                  }}
                  time
                />
              </Styled.DateBox>
              <Styled.DateBox>
                <ReservationDate
                  name={t("common.endDay")}
                  dateName="endDate"
                  date={endDate}
                  onChange={(date: any) => {
                    setEndDate(dayjs(date));
                  }}
                />
                <ReservationDate
                  name={t("common.time")}
                  dateName="endTime"
                  date={endTime}
                  onChange={(date: any) => {
                    setEndTime(dayjs(date));
                  }}
                  time
                />
              </Styled.DateBox>
              <Styled.Line />
              <div>
                <Styled.BottomTitleBox>
                  <Styled.DateName>
                    {t("common.checkReservation")}
                  </Styled.DateName>
                  <GOButton
                    body={t("reservation.searchPeopleInReservation")}
                    onClick={() => {
                      onDeleteUserList();
                      setSearchState(true);
                    }}
                  />
                </Styled.BottomTitleBox>
                {data?.length > 0 ? (
                  <>
                    <Styled.ReservationUserList>
                      {data.map((d: any, index: number) => (
                        <React.Fragment key={index}>
                          <Styled.ReservationUser>
                            <Styled.ReservationUserWrapper>
                              <Styled.UserName>{d.userName}</Styled.UserName>
                              <Styled.ReservationDate>
                                {dayjs(d.startDate).format("YYYY.MM.DD")}
                              </Styled.ReservationDate>
                              <Styled.ReservationTime>
                                {dayjs(d.startDate).format("a hh:mm")}
                              </Styled.ReservationTime>
                              <Styled.ReservationCancel
                                onClick={() => {
                                  onReservationCancel(d.plateReservationID);
                                }}
                              >
                                {t("reservation.cancelReservation")}
                              </Styled.ReservationCancel>
                            </Styled.ReservationUserWrapper>
                          </Styled.ReservationUser>
                        </React.Fragment>
                      ))}
                    </Styled.ReservationUserList>
                  </>
                ) : (
                  <>
                    <Styled.ReservationUserList>
                      <Styled.NoReservationText>
                        {data?.length === 0 && (
                          <div>{t("reservation.noReservation")}</div>
                        )}
                      </Styled.NoReservationText>
                    </Styled.ReservationUserList>
                  </>
                )}
              </div>
              {delState ? (
                <>
                  <Styled.WarningText>
                    {t("reservation.cancelReservationBeforeDelete")}
                  </Styled.WarningText>
                </>
              ) : (
                <>
                  <Styled.WarningText></Styled.WarningText>
                </>
              )}
            </div>
          </UFloatingBoxBody>
          <UFloatingBoxFooter>
            <GOButton
              buttontype="red"
              onClick={handleSubmit}
              body={t("reservation.delete")}
              loading={delState}
              disabled={delState}
            />
            <GOButton
              body={t("common.no")}
              onClick={() => {
                props.onClickExit();
                if (searchState || delState) {
                  props.update();
                }
              }}
              disabled={delState}
            />
          </UFloatingBoxFooter>
        </UFloatingContainer>
      </GOFloatingbox>
    </>
  );
}

export default Delete;
